import { Card } from '@heathmont/moon-components';
import { rem } from '@heathmont/moon-utils';
import styled from 'styled-components';

type Props = {
  isLivecasino?: boolean;
};

const ProviderCardContainer = styled(Card)<Props>`
  && {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.5fr);
    padding: 0;
    gap: 0;
    overflow: hidden;
    height: ${rem(260)};
    border-radius: ${rem(4)};
    transition: all ${({ theme }) => theme.transition.default};
    background-color: ${({ isLivecasino, theme }) =>
      isLivecasino ? theme.color.goku[100] : theme.color.goten[100]};
    &:hover {
      box-shadow: 0 0 ${rem(24)} 0 rgba(0, 0, 0, 0.1);
    }
    & button {
      transition: all ${({ theme }) => theme.transition.default};
      opacity: 0;
      transform: translateY(${rem(16)});
    }
    &:hover button {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export default ProviderCardContainer;
